import { Code, Brain, BarChart } from 'lucide-react';

export const FEATURES = [
    {
        icon: Code,
        title: "Build",
        label: "Create Intelligent Conversations",
        sublabel: "The foundation stage where your chatbot is designed, trained, and integrated with your knowledge base to create a system that authentically represents your brand.",
        points: [
            "Custom knowledge base integration with your existing data",
            "Intent recognition and conversation flow design",
            "Personality and tone alignment with your brand voice"
        ],
        tags: ['Training', 'Integration', 'Customization']
    },
    {
        icon: Brain,
        title: "Learn",
        label: "Continuous Improvement Through Use",
        sublabel: "The evolution stage where your chatbot analyzes conversations, identifies gaps in knowledge, and refines its responses based on real customer interactions.",
        points: [
            "Real-time learning from customer conversations",
            "Automated knowledge gap identification",
            "Human-in-the-loop feedback mechanisms for edge cases"
        ],
        tags: ['Adaptation', 'Refinement', 'Feedback']
    },
    {
        icon: BarChart,
        title: "Grow",
        label: "Scale Impact Across Your Business",
        sublabel: "The expansion stage where your mature chatbot extends across channels, departments, and use cases, becoming an integral part of your business operations.",
        points: [
            "Cross-department knowledge sharing and accessibility",
            "Expanded use cases from support to sales to operations",
            "Integration with business analytics for strategic insights"
        ],
        tags: ['Expansion', 'Integration', 'Analytics']
    }
];